const {
  getSessionCookie,
  saveSessionCookie
} = require("../../utils/cookies");

const yup = require('yup');

const {
  requiredString,
  requiredEmail,
  requiredBool
} = require('../utils');
/**
 * The name of the collection for this model in Firestore
 * @type {string}
 */


const COLLECTION = 'users';
/**
 * Yup schema for this model
 */

const SCHEMA = yup.object().shape({
  uid: requiredString(),
  email: requiredEmail(),
  admin: requiredBool().default(false)
});
/**
 * This object defines custom queries to perform on the data, outside of the normal CRUD operations
 */

const QUERIES = {};
/**
 * Methods added here will trigger https-callable Cloud Functions
 */

const CALLABLES = {
  // KBM - We should be able to get the Firebase Token from the Auth header, so no need to pass it
  createSessionCookie: () => ({
    data: {},
    onResponse: response => {
      saveSessionCookie(response);
    }
  }),
  getUserInfo: (domain = document.domain) => ({
    data: {
      domain,
      sessionCookie: getSessionCookie()
    }
  })
};
/**
 * Methods added here will be appended to each returned document from the collection
 */

const MIXINS = {};
/**
 * Dates are a bit of a pitd with Firestore, so implement this method to convert any timestamp fields to JS Date objects
 * when records are inflated from Firestore, since ultimately we need to pass Date objects back to Firestore when saving
 * records
 * @param model The inflated object from Firestore
 * @returns the model with the appropriate Timestamps converted to JS Dates
 */

const convertDates = model => {
  return model;
};

module.exports = {
  COLLECTION,
  SCHEMA,
  QUERIES,
  CALLABLES,
  MIXINS,
  convertDates
};